import * as React from "react";
import type { SVGProps } from "react";
const SvgFileLock01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.6 21.6H7.2A3.6 3.6 0 0 1 3.6 18V6a3.6 3.6 0 0 1 3.6-3.6h8.4A3.6 3.6 0 0 1 19.2 6v3M15 15v-1.2a1.8 1.8 0 0 1 3.6 0v1.8m-4.2 6h4.8a1.2 1.2 0 0 0 1.2-1.2v-3.6a1.2 1.2 0 0 0-1.2-1.2h-4.8a1.2 1.2 0 0 0-1.2 1.2v3.6a1.2 1.2 0 0 0 1.2 1.2"
    />
  </svg>
);
export default SvgFileLock01;
